import FilterInput from './filterInput';

export default FilterInput;
